import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { axiosInstance } from "../../Config";
import { toast } from "react-toastify";

const UpdateIncome = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [start, setStart] = useState(0);
    const [end, setEnd] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchIncome = async () => {
            try {
                const response = await axiosInstance.get(`/getIncome/${id}`);

                if (response.data.success) {
                    setStart(response?.data?.body?.start ?? 0);
                    setEnd(response?.data?.body?.end ?? "");
                }

            } catch (err) {
                setError("Failed to fetch income data");
            }
        };

        fetchIncome();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

     if (start === "" || start === null) {
  setError("Minimum income is required.");
  return;
}

if (end && Number(start) >= Number(end)) {
  setError("Maximum income must be greater than minimum income.");
  return;
}
        try {
            const response = await axiosInstance.post(`/updateIncome/${id}`, {
                start,
                end
            });

            if (response.data.success) {
                toast.success('Income updated successfully');

                setTimeout(() => {
                    navigate('/incomeList');
                }, 1200);
            }

        } catch (err) {
            setError(err?.response?.data?.message || "Failed to update income.");
        }
    };
    useEffect(() => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
    
            const backdrops = document.querySelectorAll('.modal-backdrop, .offcanvas-backdrop');
            backdrops.forEach(el => el.remove());
        }, []);

    return (
        <div id="layout-wrapper">
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">

                        <div className="title-box mb-3 pb-1">
                            <h4 className="mb-0 page-title">Update Income</h4>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard" className="new">
                                            <i className="ri-home-4-fill me-1" /> Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/incomeList" className="new">
                                            Income
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Update Income
                                    </li>
                                </ol>
                            </nav>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">

                                        {error && (
                                            <div className="alert alert-danger">
                                                {error}
                                            </div>
                                        )}

                                        <form onSubmit={handleSubmit}>

                                            <div className="mb-3">
                                                <label className="mb-1 fw-medium">Minimum Income (in $)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={start}
                                                    onChange={(e) => setStart(e.target.value)}
                                                    placeholder="Enter minimum income"
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="mb-1 fw-medium">Maximum Income (in $)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={end}
                                                    onChange={(e) => setEnd(e.target.value)}
                                                    placeholder="Leave empty for '+' (e.g. 100000+)"
                                                />
                                            </div>
<div className="alert alert-info mt-2">
  <strong>Note:</strong>
  <ul className="mb-0">
    <li>If <b>Minimum = 0</b> → "Less than $X"</li>
    <li>If both values are entered → "$X - $Y"</li>
    <li>If <b>Maximum is empty</b> → "$X+"</li>
  </ul>
</div>
                                            <div className="text-end mb-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2 px-4"
                                                    onClick={() => navigate('/incomeList')}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    type="submit"
                                                    className="btn btn-danger px-4"
                                                >
                                                    Update Income
                                                </button>
                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateIncome
